import { matchRoutes } from 'react-router-dom';
import { telemetryPathValues, briefPageTypes } from 'paths';

const telemetryRoutes = telemetryPathValues.map((path) => ({ path }));

const getRouteContext = (path?: string) => {
  // eslint-disable-next-line no-restricted-globals
  const pathname = path ?? location.pathname;

  const matches = matchRoutes(telemetryRoutes, pathname);
  const match = matches?.[matches.length - 1];
  const params = match?.params ?? {};
  const { owner: rawOwner, briefKey: briefSlug, id, slideId } = params;

  const owner = rawOwner?.startsWith('@') ? rawOwner.slice(1) : rawOwner;

  // Extract briefKey and briefId from slug like "my-plan-123"
  const briefKeyParse = briefSlug
    ? /^(?<briefKey>.+)-(?<briefId>[0-9]+)$/.exec(briefSlug)
    : null;
  const briefKey = briefKeyParse?.groups?.briefKey;
  const briefId = briefKeyParse?.groups?.briefId
    ? Number(briefKeyParse.groups.briefId)
    : undefined;

  // Derive pageType from URL segment at index 3 (/@owner/briefSlug/<pageType>/...)
  const pageTypeSegment = pathname.split('/')[3];
  const pageType =
    owner && briefSlug && pageTypeSegment && briefPageTypes.has(pageTypeSegment)
      ? pageTypeSegment
      : undefined;

  return {
    pageId: pathname,
    genericPath: match?.route.path ?? pathname,
    briefKey,
    briefId,
    artifactId: id,
    pageType,
    presentationId: pageType === 'presentation' ? id : undefined,
    slideId,
    boardId: pageType === 'board' ? id : undefined,
    fileId: pageType === 'files' ? id : undefined,
    orderId: pageType === 'order' ? id : undefined,
    mapId: pageType === 'maps' ? id : undefined,
    sectionId: pageType === 'sections' ? id : undefined,
    owner,
  };
};

export { getRouteContext };
